/*jshint strict: false */
(
    function (window, document, $, _) {
        function toggleRegistrationQuestions(e) {
            var industrySelect,
                selectedIndustry,
                rqContainer = $('#registrationQuestions'),
                rqData = [],
                rqElems = [];

            if ($.isWindow(this)) {
                industrySelect = $('#industry');
            } else if (_.isElement(this) && $(this).attr('id') === 'industry') {
                industrySelect = $(this);
            }

            rqContainer.find('input[id^="rq_"]').each(
                function () {
                    $(this).rules('remove');
                }
            );
            rqContainer.html('');

            if (!_.isUndefined(industrySelect)) {
                selectedIndustry = _.parseInt(industrySelect.val());

                rqData = _.filter(
                    window.regQs,
                    function (rq) {
                        return rq.industryId === selectedIndustry;
                    }
                );

                if (!_.isEmpty(rqData)) {
                    _.forEach(
                        rqData,
                        function (rq, i, a) {
                            var rqElem = $(window.regQsTemplates[rq.type]),
                                rqElemInput = rqElem.find('input'),
                                rqElemLabel = rqElem.find('label'),
                                rqElemError = rqElem.find('span.invalid-feedback'),
                                idGenerator = _.template('rq_${industryId}_${rqId}'),
                                labelEscape = _.template('<%- label %>'),
                                idName = idGenerator({industryId: rq.industryId, rqId: rq.id}),
                                labelText = labelEscape({label: rq.question}),
                                hasError = !_.isEmpty(rq.error);

                            if (i === a.length - 1) {
                                rqElem.addClass('mb-4');
                            } else {
                                rqElem.addClass('mb-2');
                            }

                            rqElemInput.attr('id', idName)
                                .attr('name', idName);

                            if (rq.type === 'checkbox') {
                                rqElemInput.attr('checked', rq.answer)
                                    .prop('checked', rq.answer);
                            } else {
                                rqElemInput.attr('value', rq.answer)
                                    .val(rq.answer);
                            }

                            if (hasError) {
                                rqElemInput.addClass('is-invalid');

                                if (rq.type === 'checkbox') {
                                    rqElemError.css('display', 'inline');
                                }

                                rqElemError.find('strong')
                                    .html(rq.error);
                            }

                            rqElemLabel.attr('for', idName)
                                .text(labelText);

                            rqElems.push(rqElem);
                        }
                    );

                    if (rqElems.length > 0) {
                        _.forEach(
                            rqElems,
                            function (rqe) {
                                rqContainer.append(rqe);
                            }
                        );
                    }

                    _.forEach(
                        rqData,
                        function (rq) {
                            var idGenerator = _.template('#rq_${industryId}_${rqId}'),
                                id = idGenerator({industryId: rq.industryId, rqId: rq.id}),
                                input = $(id),
                                rules = {
                                    required: false
                                },
                                generateRequiredCallback = function (industryId) {
                                    return function () {
                                        return _.parseInt($('#industry').val()) === _.parseInt(industryId);
                                    };
                                };

                            if (rq.required) {
                                rules.required = generateRequiredCallback(rq.industryId);
                                rules.messages = 'This question is required.';
                            }

                            input.rules('add', rules);
                        }
                    );
                }
            }
        }

        $(document).ready(
            function () {
                var industrySelect = $('#industry');

                industrySelect.on(
                    'change.one-health',
                    toggleRegistrationQuestions
                );

                toggleRegistrationQuestions();
            }
        );
    }
)(window, document, window.jQuery, window._);
